import { Injector } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent, HttpErrorResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { AuthServerProvider } from 'src/app/core/auth/auth-session.service';
import { LoginModalService } from 'src/app/core/login/login-modal.service';
import { StateStorageService } from 'src/app/core/auth/state-storage.service';
import { ActivatedRoute, Router } from '@angular/router';
import { JhiAlertService } from 'ng-jhipster';

export class AuthExpiredInterceptor implements HttpInterceptor {
    private alertService: JhiAlertService;

    constructor(
        private stateStorageService: StateStorageService,
        private injector: Injector,
        private activatedRoute: ActivatedRoute,
        private router: Router
    ) {
        setTimeout(() => (this.alertService = injector.get(JhiAlertService)));
    }

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        return next.handle(request).pipe(
            tap(
                (event: HttpEvent<any>) => {},
                (err: any) => {
                    if (err instanceof HttpErrorResponse) {
                        if (err.status === 401 && err.url && !err.url.includes('/api/account')) {
                            const destination = this.stateStorageService.getDestinationState();
                            if (destination !== null) {
                                const to = destination.destination;
                                const toParams = destination.params;
                                if (to.name === 'accessdenied') {
                                    this.stateStorageService.storePreviousState(to.name, toParams);
                                }
                            } else {
                                if (err.error.message === 'UNAUTHORIZED_ACCESS') {
                                    if (!err.url.includes('/api/account')) {
                                        this.alertService.error(err.error.payload, null, null);
                                    }
                                }
                                 if (
                                   err.error.error === "Forbidden"
                                 ) {
                                   this.alertService.error(err.error.message,
                                     null,
                                     null
                                   );
                                 }
                                this.stateStorageService.storeUrl('/');
                            }
                            this.alertService.error(err.error.message, null, null);

                            const authServer: AuthServerProvider = this.injector.get(AuthServerProvider);
                            authServer.logout();
                            const loginModalService: LoginModalService = this.injector.get(LoginModalService);
                            // loginModalService.open();
                            // this.router.navigateByUrl('/');
                        } else if (err.status === 500 && err.url && err.url.includes('/api/account')) {
                            this.alertService.error(err.error.message, null, null);
                        }
                    }
                }
            )
        );
    }
}
